export default __webpack_public_path__ + "58e54a58cc0df98e5399a0e02dd299f0.svg";